import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { WrapperPublicComponent } from './shared/components/wrapper-public/wrapper-public.component';
import { WrapperComponent } from './shared/components/wrapper/wrapper.component';
import { AuthGuardAdmin } from './shared/guards/admin.guard';
import { AuthGuard } from './shared/guards/auth.guard';
import { AuthGuardRoot } from './shared/guards/root.guard';
import { UniqueCodeViewComponent } from './unique-code/unique-code-view/unique-code-view.component';

const routes: Routes = [
  {
    path: 'unique-code',
    // component: WrapperPublicComponent,
    component: UniqueCodeViewComponent,
    loadChildren: () => import('./unique-code/unique-code.module').then(m => m.UniqueCodeModule)
  },
  {
    path: 'reg',
    component: WrapperPublicComponent,
    loadChildren: () => import('./registration-online/registration-online.module').then(m => m.RegistrationOnlineModule)
  },
  {
    path: 'theses',
    component: WrapperPublicComponent,
    loadChildren: () => import('./theses/theses.module').then(m => m.ThesesModule)
  },
  {
    path: 'abstract-review',
    component: WrapperPublicComponent,
    loadChildren: () => import('./abstract-review/abstract-review.module').then(m => m.AbstractReviewModule)
  },
  {
    path: 'unsubscribe',
    component: WrapperPublicComponent,
    loadChildren: () => import('./unsubscribe/unsubscribe.module').then(m => m.UnsubscribeModule)
  },
  {
    path: 'subscribe',
    component: WrapperPublicComponent,
    loadChildren: () => import('./subscribe/subscribe.module').then(m => m.SubscribeModule)
  },

  // { path: 'abstract_review/:abstractId', loadChildren: () => import('./abstract/abstract.module').then(m => m.AbstractModule) },
  {
    path: '',
    component: WrapperComponent,
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        pathMatch: 'full', component: HomeComponent
      },
      {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
      },
      {
        path: 'geo',
        canActivateChild: [AuthGuardRoot],
        loadChildren: () => import('./geo/geo.module').then(m => m.GeoModule)
      },
      {
        path: 'users',
        canActivateChild: [AuthGuardRoot],
        loadChildren: () => import('./user/user.module').then(m => m.UserModule)
      },
      {
        path: 'iacmac-import',
        canActivateChild: [AuthGuardRoot],
        loadChildren: () => import('./iacmac/iacmac.module').then(m => m.IacmacModule)
      },
      {
        path: 'conferences',
        canActivateChild: [AuthGuardAdmin],
        loadChildren: () => import('./conference/conference.module').then(m => m.ConferenceModule)
      },
      {
        path: 'geo-replacements',
        canActivateChild: [AuthGuardAdmin],
        loadChildren: () => import('./geo-replacement/geo-replacement.module').then(m => m.GeoReplacementModule)
      },
      {
        path: 'stat',
        canActivateChild: [AuthGuardAdmin],
        loadChildren: () => import('./stat/stat.module').then(m => m.StatModule)
      },
      {
        path: 'people',
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./people/people.module').then(m => m.PeopleModule)
      },
      {
        path: 'abstract',
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./abstract/abstract.module').then(m => m.AbstractModule)
      },
      {
        path: 'email-messages',
        canActivateChild: [AuthGuardRoot],
        loadChildren: () => import('./email-messages/email-messages.module').then(m => m.EmailMessagesModule)
      },
      // TODO: MAKE AUTH GUARD
      // { path: 'abstract', loadChildren: () => import('./abstract/abstract.module').then(m => m.AbstractModule) },
      {
        path: 'registration',
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./registration/registration.module').then(m => m.RegistrationModule)
      },
      {
        path: 'dictionaries',
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./dictionaries/dictionaries.module').then(m => m.DictionariesModule)
      },

      { path: 'notallowed', loadChildren: () => import('./not-allowed/not-allowed.module').then(m => m.NotAllowedModule) },

    ]
  },
  { path: '**', loadChildren: () => import('./not-found/not-found.module').then(m => m.NotFoundModule) },

];
export const routingConfiguration: ExtraOptions = {
    paramsInheritanceStrategy: 'always'
};
@NgModule({
  imports: [RouterModule.forRoot(routes, routingConfiguration)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
